// PrioritizedUpcsByCategory.js
// Configuration for prioritizing specific UPCs within categories
//
// Usage:
//   Map category names to arrays of UPCs (as strings)
//   Products with these UPCs will appear first in the category, in the order specified

const prioritizedUpcsByCategory = {
  // Example configuration:
  // "Fresh Fruit": [
  //   "0000000001234",
  //   "0000000005678"
  // ],
  // "Water": [
  //   "0000000009012"
  // ]
};

export default prioritizedUpcsByCategory;

